import { CARD_LIMIT } from './Data';
export const URL_GET_ACTIVITY_LOGS = `/log/activities?_limit=${CARD_LIMIT}%(params)s`;

// Types
export const types = {
    GET_ACTIVITY_LOGS_LOADING: 'GET_ACTIVITY_LOGS_LOADING',
    GET_ACTIVITY_LOGS_SUCCESS: 'GET_ACTIVITY_LOGS_SUCCESS',
    GET_ACTIVITY_LOGS_FAILED: 'GET_ACTIVITY_LOGS_FAILED',
};
